import React, { useEffect  } from 'react'
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import Header from '../parts/Header'
import ApiSubHeader from '../parts/ApiSubHeader'

// ApiManagerModels
const ApiManagerModels = (props) => {

  let navigate = useNavigate();
  let login_token = useSelector(state => {
    if (state.user && state.user.login_token) {
      return state.user.login_token
    } else {
      return ''
    }
  });
  // let [loading, setLoading] = useState(false);

  // componentDidMount
  useEffect(() => {
    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let _firstScript = () => {
    if (!login_token) {
      // redirect
      navigate("/dashboard")
    }
  }

  return (
    <div>

      <Header />

      <ApiSubHeader />

      {/* main */}
      <Container style={{
        marginTop: 40,
      }}>

        <Row style={{
          marginTop: 20,
          marginBottom: 20,
        }}>
          <Col md="12" xs="12" style={{
            textAlign: 'left',
          }}>
            <span>
              利用可能モデル
            </span>
          </Col>
        </Row>
        <Row style={{
          marginTop: 20,
          marginBottom: 20,
        }}>
          <Col md="3" xs="12" style={{
            textAlign: 'left',
          }}>
            <span>
              伝説の野球モデル
            </span>
          </Col>
          <Col md="9" xs="12" style={{
            textAlign: 'left',
          }}>
            <span>
              https://baseball.shabelab.com/transcribe
            </span>
          </Col>
        </Row>

      </Container>

    </div>
  )
}

export default ApiManagerModels
